// Funciones puras del carrito del POS (sin Vue ni red).

// Redondeo a 2 decimales, igual que round(x, 2) del backend.
export function redondear2(n) {
  return Math.round((Number(n) + Number.EPSILON) * 100) / 100;
}

// [1d] Descuento de una línea de combo, ya redondeado (el backend redondea cada línea).
export function descuentoLineaCombo(precioUnitario, porcentaje, cantidad = 1) {
  return redondear2((Number(precioUnitario) || 0) * cantidad * (Number(porcentaje) || 0) / 100);
}

// [1d] Totales del carrito con el mismo cálculo que ProcesarVentaService:
// total = Σ round(cantidad × precio, 2) − Σ round(descuento_neto, 2) − descuento_manual.
// descuento_neto es el descuento de la LÍNEA (no por unidad).
export function totalesCarrito(carrito, descuentoManual = 0) {
  let subtotal = 0;
  let descuento = 0;
  carrito.forEach(item => {
    subtotal += redondear2((parseFloat(item.precioBase) || 0) * item.cantidad);
    descuento += redondear2(parseFloat(item.descuento_neto) || 0);
  });
  subtotal = redondear2(subtotal);
  descuento = redondear2(descuento);
  const total = redondear2(Math.max(0, subtotal - descuento - (parseFloat(descuentoManual) || 0)));
  return { subtotal, descuento, total };
}

// [1f] Clave única del catálogo: productos, paquetes y smart combos comparten el espacio de id.
export function claveCatalogo(item) {
  if (item.es_smart_combo) return `combo:${item.id}`;
  if (item.es_paquete) return `paquete:${item.id}`;
  return `producto:${item.id}`;
}

// [1f] Quita repetidos por clave (no por id).
export function unicosPorClave(lista) {
  return Array.from(new Map(lista.map(item => [claveCatalogo(item), item])).values());
}

// [1a] Bordes (GET /producto/bordes) y extras (GET /producto/extras) con la forma que usa el modal de combo.
export function normalizarComplementos(bordes = [], extras = []) {
  const base = (c) => ({
    ...c,
    nombre: c.nombre || c.descripcion,
    precioBase: parseFloat(c.precio_venta || 0),
    es_paquete: false,
    es_smart_combo: false,
    es_complemento: true
  });
  return [
    ...bordes.map(b => ({ ...base(b), es_borde: true })),
    ...extras.map(e => ({ ...base(e), extra: true }))
  ];
}

// [1h] Precio de un producto según el canal de venta: 3 → pv2 (Yango), 2 → pv3 (PedidosYa), 4 → pv4 (Turbo), 6 → pv5 (Cortesía).
// Solo usa el pv si es > 0; si está vacío, null o "0.00" (o el canal no tiene pv), devuelve el precio base.
const CAMPO_PV_POR_CANAL = { 3: 'pv2', 2: 'pv3', 4: 'pv4', 6: 'pv5' };
export function precioCanal(obj, canalId, base) {
  const campo = CAMPO_PV_POR_CANAL[canalId];
  const p = campo && obj ? parseFloat(obj[campo]) : NaN;
  // Para Cortesía (canal 6), el 0 es un precio válido
  if (canalId === 6 && !isNaN(p)) {
    return p;
  }
  return p > 0 ? p : base;
}
